import { Link } from "react-router-dom";
import { Trophy, MapPin, CalendarDays, Instagram, Facebook, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-league-ink text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <img src="/asl-logo-white.png" alt="All Star League crest" className="h-12 w-auto" />
            <span className="font-display text-2xl tracking-wide">
              ALL STAR LEAGUE <span className="text-league-red">6.0</span>
            </span>
          </div>
          <p className="text-white/60 text-sm leading-relaxed max-w-sm">
            Surat's own cricket carnival. Five seasons of legends behind us — the sixth edition lands this February, and it's the biggest one yet.
          </p>
          <div className="flex gap-3 mt-6">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 transition-colors duration-200 hover:bg-league-blue hover:border-league-blue hover:text-white"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-oswald uppercase tracking-[0.2em] text-xs text-white/40 mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            {[["News & Updates", "/news"], ["Past Winners", "/winners"], ["Fan Polls", "/polls"], ["Live Matches", "/live"], ["Live Auction", "/auction"]].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-white/70 transition-colors duration-200 hover:text-white" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="font-oswald uppercase tracking-[0.2em] text-xs text-white/40 mb-5">Season 6</h4>
          <div className="space-y-4 text-sm">
            <div className="flex items-center gap-3 text-white/70">
              <MapPin size={16} className="text-league-red shrink-0" />
              <span>Surat, Gujarat, India</span>
            </div>
            <div className="flex items-center gap-3 text-white/70">
              <CalendarDays size={16} className="text-league-red shrink-0" />
              <span>19–21 February 2027 — Umra Cricket Ground</span>
            </div>
          </div>
          <div className="mt-8 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-league-blue/20 border border-league-blue/40 text-league-blue text-xs font-bold uppercase tracking-widest">
            <span className="w-2 h-2 rounded-full bg-league-red animate-pulse" />
            Season 6 incoming
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40 tracking-wider uppercase">
        All Star League, Surat — Built by the community, for the community
      </div>
    </footer>
  );
}
